/**
 * Global Functionality
 * The logic in this is intended to ONLY contain any functionality
 * that is required on every page load.
 *
 * NOTE: Please do not include any page-specific logic here.
 **/

import Cart from "./cart";
import Logger from "../lib/logger";
import ThemeFooter from "../partials/ThemeFooter";
import ThemeHeader from "../partials/ThemeHeader";
import ThemeMiniCart from "../partials/ThemeMiniCart";
import ThemeScreensaver from "../partials/ThemeScreensaver";

import { recordSearchSubmission } from './nosto-client.js';
import { initLazyAutocomplete } from './lazy-autocomplete.js';
import { freshSearchUrl } from './search-state.js';
import { initIntercom } from './intercom.js';

export default function () {
	const NAME = 'Global';
	let searchClient;
	Logger.info(`${NAME} > loading`);

	// Vars
	// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
	const cart = new Cart();

	const themeHeaderDom = document.querySelector(`[data-theme-header]`);

	const themeMiniCartDom = document.querySelector(`[data-theme-mini-cart]`);
	const themeScreensaverDom = document.querySelector(`[data-theme-screensaver]`);

	// Logic
	// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

	/**
	 * init --- Initialization block
	 */
	function init() {
		Logger.info(`${NAME} > init`);
		initFooter();
		initHeader();
		initMiniCart();
		initScreensaver();
		initSearchForms();

		if (!window.themeTrackingSuppressed) {
			initIntercom();
			initLazyAutocomplete({ submit: submitSearch, onClient: client => { searchClient = client; } });
		}

		// Get the current cart contents
		cart.get();

		return {
			cart: cart,
		};
	}

	/**
	 * initHeader - Initialize the main header
	 */
	function initHeader() {
		Logger.info(`${NAME} > initHeader`);
		if (!themeHeaderDom) return;
		const el = new ThemeHeader(themeHeaderDom, cart);
		el.init();
	}

	/**
	 * initFooter - Initialize the main footer
	 */
	function initFooter() {
		Logger.info(`${NAME} > initFooter`);
		const el = new ThemeFooter();
		el.init();
	}

	/**
	 * initMiniCart - Initialize the main mini cart
	 */
	const initMiniCart = () => {
		if (!themeMiniCartDom) return; 
		Logger.info(`${NAME} > initMiniCart`);
		const miniCart = new ThemeMiniCart(themeMiniCartDom, cart);
		miniCart.init();
	};

	const initScreensaver = () => {
		Logger.info(`${NAME} > initScreensaver`);

		if (!themeScreensaverDom) return;

		const el = new ThemeScreensaver(themeScreensaverDom);
		el.init();
	}


	function submitSearch(query, action, options = {}) {
		if (!query.trim()) return;
		try {
			sessionStorage.removeItem('nosto-search-keyword');
			if (options.isKeyword) sessionStorage.setItem('nosto-search-keyword', query);
		} catch (error) {}
		if (!window.themeTrackingSuppressed) {
			let storage;
			try { storage = sessionStorage; } catch (error) {}
			recordSearchSubmission(searchClient, query, storage);
		}
		window.location.assign(freshSearchUrl(window.location.href, action, query).href);
	}

	function initSearchForms() {
		document.querySelectorAll('[data-store-search-form]').forEach(form => {
			form.addEventListener('submit', event => {
				event.preventDefault();
				event.stopImmediatePropagation();
				submitSearch(form.elements.q.value, form.action);
			}, { capture: true });
		});
	}


	// Do not edit below this line...
	// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
	Logger.info(`${NAME} > loaded`);

	return init();
}
